module.exports = __webpack_public_path__ + "img/offers-blue.48516d42.svg";